
import React from "react";
import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";
import { ScrollArea } from "@/components/ui/scroll-area";

interface ErrorDisplayProps {
  error: string;
  logs?: string[];
}

export function ErrorDisplay({ error, logs }: ErrorDisplayProps) {
  return (
    <Card className="w-full h-full min-h-[300px]">
      <CardHeader>
        <CardTitle className="text-red-500">Execution Error</CardTitle>
      </CardHeader>
      <CardContent>
        <p className="font-semibold">Error: {error}</p>
        
        {logs && logs.length > 0 && (
          <div className="mt-8">
            <h3 className="text-lg font-semibold mb-2">Execution Logs</h3>
            <ScrollArea className="h-60 w-full rounded-md border p-4 bg-gray-50 dark:bg-gray-900">
              {logs.map((log, index) => (
                <div key={index} className="pb-1">
                  <code className="text-xs font-mono">{log}</code>
                </div>
              ))}
            </ScrollArea>
          </div>
        )}
      </CardContent>
    </Card>
  );
}
